module.exports = __webpack_public_path__ + "static/img/sgsi.3a5fa6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sgsi.png
// module id = S7js
// module chunks = 0